/* * API Endpoints for login module */
export const loginURL = "/auth/login";
export const onboardingURL = "/onboard/onboarding-data";
export const refreshTokenURL = "/auth/refresh-token";
export const logoutURL = "/auth/logout";
export const onboardConnectedURL = "/onboard/connected";
export const validateUserURL = "/auth/validate-user";
export const getOnboardDisconnectedURL = (accountingSoftwareId) =>
  `/onboard/${accountingSoftwareId}/disconnect`;

/* * API Endpoints for user management module */
export const getHasPermissionURL = (permissionType) =>
  `/auth/has-permission?permissionType=${permissionType}`;

export const userManagementProfileURL = "/user-mgmt/profile";
export const userManagementUsersURL = (id) => `/user-mgmt/users/${id}`;
// The account comes from the token, so no id in the path — a customer can only
// ever record their own identifiers.
export const marketingIdentifiersURL = "/user-mgmt/users/marketing-identifiers";
export const getUserManagementUsersDataURL = (id) => {
  return `/user-mgmt/users/${id}`;
};
export const getSecondaryUsersDataURL = (id) => {
  return `/user-mgmt/users/${id}/secondary-users`;
};
export const getUserCountryInfoURL = (id) => {
  return `/user-mgmt/country-info/${id}`;
};
export const getUserManagementProfileUpdateURL = (params) => {
  return `/user-mgmt/users/${params.id}/business-detail?key=${encodeURIComponent(params.key)}&value=${encodeURIComponent(params.value)}`;
};
export const getUserManagementDeleteURL = (id) =>
  `/user-mgmt/users/${id}/soft-delete`;

export const getUserManagementBulkActionURL = `/user-mgmt/users/bulk-action?action=force-delete`;
export const getUserManagementMetadataURL = `/user-mgmt/user-account-metadata`;
export const getUserUpdateMetaURL = (id) =>
  `/user-mgmt/user-account-metadata/${id}`;
export const getUserMetadataUpdateURL = (userAccountId) =>
  `/user-mgmt/user-account-metadata/update-metadata/${userAccountId}`;

/**API verify-confirmation-email */
export const getUserManagementVerifyEmailURL = (token) =>
  `/user-mgmt/users/verify-confirmation-email/${token}`;

export const getUserManagementInfoURL = (id) =>
  `/user-mgmt/users/${id}/user-information`;
/** API  pagination */
export const getUserMngRolewithoutPaginationURL = `/user-mgmt/roles/without-pagination`;
/**Api roles with permissions */
export const getUserMngRoleWithPermissionsURL = `/user-mgmt/roles/with-permissions`;

/** API  Create */
export const getUserManagementCreateURL = `/user-mgmt/users/create`;

export const getUserManagementRestoreURL = (rowId) =>
  `/user-mgmt/users/${rowId}/restore`;

export const getUserManagementActivateURL = (rowId) =>
  `/user-mgmt/users/${rowId}/activate`;

export const getUserManagementResendURL = (id) =>
  `/user-mgmt/users/${id}/send-confirmation-email`;
export const getDeactivateUserURL = (id) => `/user-mgmt/users/${id}/deactivate`;
export const getSlectedDeletedURL = `/user-mgmt/users/bulk-action?action=soft-delete`;
export const getBulkActionDeleteURL = `/user-mgmt/users/bulk-action?action=activate`;
export const getHandleLoginUserURL = (id) => `/auth/admin/login-as-user/${id}`;
export const getLoginAsPartnerURL = (id) =>
  `/auth/admin/login-as-partner/${id}`;
export const getHandleLoginAsPermission =
  "/auth/admin/check-login-as-permission";
export const getLoadUserDataURL = `/user-mgmt/users`;
export const getUserPrimaryDataURL = (id) => `/user-mgmt/users/${id}`;
export const navItemsURL = "/user-mgmt/nav-items";
export const navItemsMenuPermissionsURL = (id) => `/user-mgmt/nav-items/${id}`;

export const getUserManagementBulkURL = `/user-mgmt/users/bulk-action?action=activate`;

export const getFinancialReportURL = (id) =>
  `/reporting/customer-financial-report/${id}`;
export const getFinancialReportDownloadURL =
  "/reporting/customer-financial-report/download";
export const getFinancialGenerateReportUrl = (id) =>
  `/reporting/customer-financial-report/${id}/generate-all-reports`;
export const getFinancialFetchReportUrl = (id) =>
  `/reporting/customer-financial-report/${id}/fetch-all-json-files`;
export const getPostCreditScoreManualUploadUrl =
  "/risk-advisor/manual-assessment/credit-score/manual-upload";
export const getCreditScoreManualUploadUrl = (id) =>
  `/risk-advisor/manual-assessment/credit-score-multiple/${id}`;
export const getCreditScoreManualDonloadUrl = (id) =>
  `/risk-advisor/manual-assessment/download/${id}`;
export const getCreditScoreCentrixDonloadUrl = (id) =>
  `/int/centrix/download-report/${id}`;
export const getFinacialReportDataUrl = (id) =>
  `/reporting/customer-financial-report/fetch-report-data/${id}`;
export const getMonthlyComissionUrl = "/reporting/sales-lead-commission/report";
export const getMonthlyComissionDownloadUrl =
  "/reporting/sales-lead-commission/download";

/** Api reporting upload question file */
export const getReportingUploadQuestionFileUrl = (questionId) =>
  `/reporting/question-responses/upload-question-file/${questionId}`;

/** Api reporting delete question file */
export const getReportingDeleteQuestionFileUrl = `/reporting/question-responses/delete-question-file`;

/** Api reporting download question file */
export const getReportingDownloadQuestionFileUrl = `/reporting/question-responses/download-question-file`;

/** Api reporting add question file */
export const getReportingAddQuestionFileUrl = `/reporting/question-responses/add-question`;

/** Api reporting update question file */
export const getReportingUpdateQuestionFileUrl = `/reporting/question-responses/update-question`;

/** Api reporting submit questions */
export const getReportingSubmitQuestionsUrl = `/reporting/batches/questions-submit-admin`;

/** Api reporting command answer */
export const getReportingCommandAnswerUrl = `/reporting/question-responses/command-answer`;

/** Api reporting update sales checklist comment */
export const getReportingUpdateSalesChecklistCommentUrl = (userId) =>
  `/reporting/notes/update-sales-checklist-comment?userAccountId=${userId}`;

export const getUserBankAccountUpdateUrl = (id) =>
  `/onboard/bank-accounts/user/${id}`;
export const getUserPropertyEnquiryUrl = (id) =>
  `/user-mgmt/equifax-property/search/${id}`;
export const getUserPropertyOrderDocUrl = (id) =>
  `/user-mgmt/equifax-property/order-document/${id}`;

export const getUserPropertyDetailsUrl = (tabIndex) =>
  `/user-mgmt/properties/${tabIndex}`;
export const getLastPropertyCheckDateUrl = (userAccountId) =>
  `/user-mgmt/properties/last-check-date/${userAccountId}`;

export const getUserPropertyDownloadUrl = "/user-mgmt/properties/download";

export const getUserPropertySoftDeleteUrl = (rowId) =>
  `/user-mgmt/properties/${rowId}/soft-delete`;

export const getUserPropertyToggleVerificationUrl = (rowId) =>
  `/user-mgmt/properties/${rowId}/toggle-verification`;

export const getUserAddressChangeUrl = `/user-mgmt/user-addresses`;

export const getUserManagementAccountMetadataURL = (userId) =>
  `/user-mgmt/user-account-metadata/${userId}`;
export const getUserAccountMetadataURL = `/user-mgmt/user-account-metadata`;

export const getFundingHandleUpdateURL = (id, creditLimit) =>
  `/user-mgmt/user-account-metadata/change-credit-limit/${id}?newCreditLimit=${creditLimit}`;

export const getOnboardAccountantUrl = (id) =>
  `/onboard/accountant?userAccountId=${id}`;

export const getOnboardUrl = `/onboard/accountant`;

export const getUserManagementsystemSettingsUrl = (id) =>
  `/user-mgmt/users/${id}/system-settings`;

export const getCustomerStatusApprovelUrl = (id) =>
  `/user-mgmt/users/${id}/approval-validation`;
export const getAutoswitchingUrl = (id) =>
  `/loan-mgmt/pricing-plans/update-pricing-plan-and-auto-switching-status/${id}`;
export const getUserPromoCodeUrl = (id) =>
  `/loan-mgmt/quote/applied/promocode/${id}`;

export const getQuoteCommentsURL = (id) => `/loan-mgmt/quote/${id}/comments`;

export const getDeleteCreditScoreUrl = (id) =>
  `/risk-advisor/manual-assessment/credit-score/delete/${id}`;
export const getFinancialCreditScoreUrl = (id) =>
  `/risk-advisor/centrix/commercial/user/${id}`;
export const getOwnerCreditScoreUrl = (id) =>
  `/risk-advisor/centrix/consumer/user/${id}`;
export const getOrganizationIdUrl = (id) =>
  `/risk-advisor/equifax/organization-identification/${id}`;
export const getOwnerEquifaxIdUrl = (id) =>
  `/risk-advisor/equifax/consumer/user/${id}`;
export const getOrganizationInqueryAcnUrl = (id) =>
  `/risk-advisor/equifax/company-enquiry/${id}`;
export const getOrganizationInqueryAbnUrl = (id) =>
  `/risk-advisor/equifax/business-enquiry/${id}`;
export const getCreditScoreDataForUpdateUrl = (id) =>
  `/risk-advisor/manual-assessment/credit-score/${id}`;
export const getCreditScoreUpdateUrl =
  "/risk-advisor/manual-assessment/credit-score/manual-update";
export const getUserSalesLeadsURL = (id) => `/user-mgmt/sales-leads/${id}`;

/**Api credit score generate user */
export const getCreditScoreGenerateUserUrl = (id) =>
  `/risk-advisor/credit-score/generate/user/${id}`;

/**Api syncShareholderAndDirector */
export const getSyncShareholderAndDirectorURL = (id) =>
  `/user-mgmt/users/${id}/syncShareholderAndDirector`;

/**Api notify activities */
export const getNotifyActivitiesURL = (id) => `/notify/activities/user/${id}`;

/* * API Endpoints for financial AR/AP module */
export const getFinancialArApURL = (id) =>
  `/reporting/customer-financial-report/refresh-ar-ap/${id}`;

/* * API Endpoints for xero write back module */
export const getXeroWritebackURL = (quoteId) =>
  `/loan-mgmt/funded-invoice-writebacks/quote/${quoteId}`;

/* * API Endpoints for xero write back update module */
export const getXeroWritebackUpdateURL =
  "/loan-mgmt/funded-invoice-writebacks/writeback-id";

/* * API Endpoints for get xero write back Resync module */
export const getXeroWritebackhandleResyncIdURL = (id) =>
  `/loan-mgmt/funded-invoice-writebacks/resync-writeback/${id}`;

export const getSubmittedInvoiceTimeReportURL =
  "/loan-mgmt/quote/submitted-invoice-time-report";

/* * API Endpoints loadManualPpsrData */
export const getloadManualPpsrDataURL = (tabIndex) =>
  `/user-mgmt/users/ppsr/${tabIndex}`;

/* * API Endpoints register PPSR nz */
export const getRegisterPpsrNzURL = (id) =>
  `/user-mgmt/ppsr/nz/${id}/discharge-financing-statement`;

/* * API Endpoints register PPSR au */
export const getRegisterPpsrAuURL = (id) =>
  `/user-mgmt/ppsr/au/${id}/discharge-financing-statement`;

/* * API Endpoints register PPSR discharge */
export const getRegisterPpsrDischargeURL = (id) =>
  `/user-mgmt/users/ppsr/${id}/discharge`;

/* * API Endpoints corporate register ppsr */

export const getRegisterPpsrCorporateURL = (id, tabIndex, associateId) =>
  `/user-mgmt/users/ppsr/${id}/trust-corporate/${tabIndex}/corporate-trust-associate/${associateId}`;

export const getRegisterPpsrRegisterCorporateURL = (id, tabIndex) =>
  `/user-mgmt/users/ppsr/${id}/trustCorporate/${tabIndex}`;

/* * API Endpoints searchppsr   */
export const getSearchPpsrURL = (convertCountry, tabIndex) =>
  `/user-mgmt/ppsr/${convertCountry}/${tabIndex}/search-financing-statement`;

/* * API Endpoints ppsr comments   */

export const getSearchcommentsPpsrURL = (tabIndex) =>
  `/user-mgmt/trust-corporates/${tabIndex}/ppsr-comments`;

/* * API Endpoints for user Sales Lead Person module */
export const getUserSalesLeadPersonUrl =
  "/user-mgmt/sales-person-leads/get-sales-person-leads";

/* * API Endpoints for user Referral Partner module */
export const userReferralPartnerUrl = "/user-mgmt/referral-partners/all";
export const userReferralPromoSignupUrl = "/user-mgmt/referral-promo-signup";

/* * API Endpoints for Id Varification module */
export const getIdVarificationURL = (id) =>
  `/onboard/aplyid/${id}/verification`;

export const getIdVarificationDownloadURL = `/onboard/aplyid/export/biometric-verification`;

/* * API Endpoint for Banner Notification*/
export const getBannerNotificationURL = "/notify/scheduled-notifications";
export const getActiveBannerNotificationURL =
  "/notify/scheduled-notifications/active";
export const getBannerLoadNotificationURL = (rowId) =>
  `/notify/scheduled-notifications/${rowId}`;
export const getDeleteBannerNotificationURL = (id) =>
  `/notify/scheduled-notifications/${id}/delete`;

/* * API Endpoint for Dashboard*/
export const getDashboardDataURL = "/loan-mgmt/quote/dashboard";
export const getInvDataExportUrl = "/loan-mgmt/quote/export/Invoice-data";
export const getDebtorInvoiceAuditLogsUrl =
  "/loan-mgmt/debtor-invoice-audit-logs/get-by-user-account-id-and-debtor-id";
export const getCustomerInvoiceStatusApprovelUrl = (id) =>
  `/loan-mgmt/quote-status/validate-by-quote/${id}`;
export const getCustomerInvoiceStatusUpdateUrl =
  "/loan-mgmt/quote-status/check-credit-limit-before-approval";
export const getCustomerStatusBulkApprovelUrl =
  "/loan-mgmt/quote-status/validate-by-quotes";

/* * API Endpoint for Quote Status*/
export const getQuoteStatusURL = "/loan-mgmt/quote-status";
export const getQuoteStatusAdvanceNzUrl = "/loan-mgmt/quote-status/advance-nz";
export const getQuoteStatusAdvanceAuUrl = "/loan-mgmt/quote-status/advance-au";

export const getQuoteFeeAdjustmentsSoftDeleteUrl = (rowId) =>
  `/loan-mgmt/quote-fee-adjustments/${rowId}/soft-delete`;

/* * API Endpoint for Referral Table*/
export const getReferralTableURL = "/user-mgmt/referral-partners";
export const getReferralTableDeleteURL = (id) =>
  `user-mgmt/referral-partners/${id}/soft-delete`;

/* * API Endpoint for Reports Module*/
export const getMonthlyLendingUrl = "/reporting/report/monthly-lending-report";
export const getOverdueReportgUrl = "/reporting/overdue-report";
export const getOverdueReportgDownloadUrl =
  "/reporting/overdue-report/download";
export const getOverdueRptQuoteDetailsUrl =
  "/reporting/overdue-report/quote-details";
export const getLTVReportsModalDetailsUrl =
  "/user-mgmt/sales-referral-reports/invoice-details";
export const getCustomerDetilsReportUrl = "/reporting/customer-details-report";
export const getLTVReportUrl = "/user-mgmt/sales-referral-reports";
export const getIndustryReportUrl =
  "/reporting/industry-sector-report/report/table";
export const getIndustryInvoiceDetailsUrl =
  "/reporting/industry-report/generate-invoice-details";
export const getAiLatestStatusUrl = (id) =>
  `/risk-advisor/report-files/leatest-status?reportFileType=${id}`;
export const getAiTrainingDataGenerateRequestUrl = (id) =>
  `/risk-advisor/report-files/generate-request?reportFileType=${id}`;
export const getReportFilesDownloadUrl = (id) =>
  `/risk-advisor/report-files/download-report-file?reportFileType=${id}`;
export const getUserRepaymentsReportUrl = "/pay-sync/customer-payments-report";
export const getManualPaymentSyncUrl = "/pay-sync/manual/auto-sync";

/* * API Endpoints for Manual Payment Sync Module */
export const getManualSyncStatusUrl = "/pay-sync/manual/status";
export const getManualSyncStartUrl = "/pay-sync/manual/start";
export const getManualSyncCurrentLogsUrl = "/pay-sync/manual/current-logs";
export const getManualSyncLastSyncUrl = "/pay-sync/manual/last-sync";

/* * API Endpoint for the invoice-sync job queue health snapshot */
export const getJobQueueHealthUrl = "/loan-mgmt/jobs/health";

export const getLessThan100DownloadURL =
  "/reporting/quote/less-than-100/download";

/* * API Endpoint getOrganizationNzbn */
export const getOrganizationNzbnURL = "/int/nzbn/organization";

/* * API Endpoint handleDownloadPDF */
export const gethandleDownloadPDFURL = (id) => `/int/company-extract/${id}`;

/* * API Endpoint for handleSync */
export const gethandleSyncURL = (getNZBN, tabIndex) =>
  `/user-mgmt/nzbn/${getNZBN}/requesters/TRUST_CORPORATE/${tabIndex}`;

/* * API Endpoint for handlePutNZBNblur */
export const gethandlePutNZBNblurURL = (nzbn, tabIndex) =>
  `/user-mgmt/nzbn/${nzbn}/requesters/TRUST_CORPORATE/${tabIndex}`;

/* * API Endpoint for saveNameFieldData */
export const getSaveNameFieldDataURL = (tabIndex, key, keyValue) =>
  `/user-mgmt/trust-corporates/${tabIndex}/business-detail?key=${encodeURIComponent(key)}&value=${encodeURIComponent(keyValue)}`;
/* * API Endpoint for PricingPlan*/

export const getPicingPlanURL = "/loan-mgmt/pricing-plans";

/* * API Endpoint RiskBased  PricingPlan update*/
export const getPicingPlanUpdateURL = (id) => `/loan-mgmt/pricing-plans/${id}`;

/** API update Name */
export const getPicingPlanUpdateNameURL = (id) =>
  `/loan-mgmt/pricing-plans/${id}/update-name`;

/** API demo quote */
export const getDemoQuoteURL = (userId) =>
  `/loan-mgmt/demo-quote/${userId}/get-quotes`;
/** */

export const getDemoQuoteSubmitURL = (userId) =>
  `/loan-mgmt/demo-quote/${userId}/submit`;

/** */
export const getDemoInvoiceByIdsURL = (userId) =>
  `/loan-mgmt/demo-invoice/${userId}/get-demo-invoice-by-ids`;

/** API update Repayment Date */
export const getDemoQuoteUpdateRepayDateURL = `/loan-mgmt/demo-quote/update-repay-date`;

/* * API Endpoint for Pricing Group*/
export const getPicingGroupURL = "/loan-mgmt/pricing-plans/get-riskbased-plan";

/** API Endpoint bulk-update-pricing-plan
 */
export const getBulkUpdatePricingPlanURL =
  "/loan-mgmt/pricing-plans/bulk-update-pricing-plan";

export const getCreditAvailabilityFundingURL = `/loan-mgmt/credit-availability/funding-section`;

export const getSubmittedInvoicesURL = "/loan-mgmt/quote/submitted-invoices";

/* * API Endpoint for Sales Group*/
export const getSalesLeadsURL = "/user-mgmt/sales-person-leads";
export const getSalesLeadSearchURL = "/user-mgmt/sales-person-leads/search";
export const getSalesEditURL = (id) => `/user-mgmt/sales-person-leads/${id}`;
export const getDeleteSalesLeadURL = (id) =>
  `/user-mgmt/sales-person-leads/${id}`;
export const getArchiveSalesLeadURL = (id) =>
  `/user-mgmt/sales-person-leads/${id}/archive-sales-person-leads`;
export const getRestoreSalesLeadURL = (id) =>
  `/user-mgmt/sales-person-leads/${id}/restore`;

/* * API Endpoint for Pricing Plan Types*/
export const getPricingTypesURL = "/loan-mgmt/pricing-plans/pricing-plan-types";

/* * API Endpoint for Pricing Plan delete Types*/
export const getDeletePricingTypesURL = (id) =>
  `/loan-mgmt/pricing-plans/${id}/delete`;
/* * API Endpoint for Pricing Plan archive Types*/
export const getArchivePricingTypesURL = (id) =>
  `/loan-mgmt/pricing-plans/${id}/archive`;
/* * API Endpoint for Pricing Plan Toggle risk based Types*/
export const getToggleDefaultRiskBasedsURL = (id) =>
  `/loan-mgmt/pricing-plans/${id}/toggle-default-risk-based`;

/* * API Endpoint for Pricing Plan toggle active status Types*/
export const getToggleActiveStatusURL = (id) =>
  `/loan-mgmt/pricing-plans/${id}/toggle-active-status`;

/* * API Endpoint for validate risk range Types*/
export const getvalidateriskrangeURL = (id) =>
  `/loan-mgmt/pricing-plans/${id}/validate-risk-range`;

/* * API Endpoint for Pricing Plan Types*/
export const getClientStatusURL = "/user-mgmt/client-status";
export const getClientStatusUserURL = (id) =>
  `/user-mgmt/client-status/users/${id}`;

/* * API Endpoint for Pricing Plan User Plans*/
export const getPricingUserPlansURL =
  "/user-mgmt/bulk-change-pricing-plan/user-plans";

export const getCreateBasicPricingPlanURL =
  "/loan-mgmt/pricing-plans/create-basic";

/* * API Endpoint for Role Management */
export const getRoleManagementURL = "/user-mgmt/roles";
export const getRoleManagementDetailsURL = (id) => `/user-mgmt/roles/${id}`;
export const getActivationURL = (id) => `/user-mgmt/roles/${id}/status`;
export const getUserRoleListURL = (id) => `/user-mgmt/roles/${id}/users`;
export const limitedAccessModelURL = (id) =>
  `/user-mgmt/roles/${id}/permissions`;

export const getUserManagementWithPermissionsURL = (id) =>
  `/user-mgmt/roles/${id}/with-permissions`;

/* * API Endpoint for Pricing Plan Logs*/
export const getPricingPlanLogsURL = "/loan-mgmt/pricing-plan-logs";
export const getPricingPlanLogsUserURL = (id) =>
  `/loan-mgmt/pricing-plan-logs/user/${id}`;

/* * API Endpoint for Monthly Commission Report*/
export const getMonthyCommsnReportURL =
  "/user-mgmt/referral-partners/monthly-commission-report";

/* * API Endpoint for ReferrerList*/
export const getReferrerListUrl =
  "/user-mgmt/referral-partners/organisation-leads/partners";

/* * API Endpoint for all-quote-download-excel*/
export const getallQuoteDownloadExcelURL =
  "/reporting/all-quote-download-excel";

/* * API Endpoint for ReferrerList*/
export const getMonthlyReportUrl =
  "/user-mgmt/referral-partners/monthly-report";

/* * API Endpoint for ReferrerList image*/
export const getreferralImageURL = (id) =>
  `/user-mgmt/referral-partners/display-image/${id}`;

/* * API Endpoint for ReferrerList image*/
export const getreferralImageIdURL = (id) =>
  `/user-mgmt/referral-partners/display-image?referralPartnerId=${id}`;

/* * API Endpoint for ReferrerList load sales lead*/
export const getLoadSalesLeadURL = (id) =>
  `/user-mgmt/sales-leads/referral-partner/${id}`;

/* * API Endpoint for  fetchReferralOrgData*/
export const getReferralOrgDataURL = `/user-mgmt/referral-partners/grouped-by-partner-type`;

/* * API Endpoint for  getBankAccountData*/
export const getBankAccountDataURL = `/user-mgmt/referral-partners/apply-organisation-bank-account`;

/* * API Endpoint for  handleDeleteSelected*/
export const getDeleteSelectedRowURL = (id) => `/user-mgmt/sales-leads/${id}`;

//API Endpoint for editReferralUser
export const getEditReferralUserURL = (id) =>
  `/user-mgmt/referral-partners/${id}`;
export const getCustomerReferralURL = (id) =>
  `/user-mgmt/referral-partners/${id}/users`;

// Provisions the partner's portal login (account + partner role) and links it to
// the referral partner. sendEmail=true also sends the set-password email;
// sendEmail=false provisions silently, which is how staff impersonation reaches a
// partner who has not been invited yet.
export const getReferralPartnerInviteURL = (id, sendEmail = true) =>
  `/user-mgmt/referral-partners/${id}/invite?sendEmail=${sendEmail}`;

/* * API Endpoint for Monthly Report Email*/
export const getMonthlyReportEmailUrl =
  "/user-mgmt/referral-partners/monthly/email";

/* * API Endpoint for Monthly Commsion Report */
export const getMonthlyCommReportURL =
  "/reporting/monthly-commission-reports/monthly-commission-report";

/* * API Endpoint for Monthly Report Download*/
export const getMonthlyReportDownloadURL =
  "/reporting/monthly-commission-reports/monthly-commission-report/download-excel";

/* * API Endpoint for Monthly Create Payment*/
export const getMonthlyCreatePaymentURL =
  "/reporting/monthly-commission-reports/monthly-commission-report/download-payment-file";

/* * API Endpoint for Monthly Report Download*/
export const getMonthlyReportMarkPaidURL =
  "/reporting/monthly-commission-reports/paid-date-update";

export const customerDeviceURL = "/reporting/customer-device";

/* * API Endpoint for Activity log*/
export const activityLogURL = "/notify/activities?status=active&order=desc";

/* * API Endpoint for Activity log*/
export const fetchLogsURL = `/notify/activities/search-invoice`;

/* * API Endpoint for Accounting Software*/
export const accountSoftwareURL = "/onboard/accounting-software";
export const accountImageDataURL = (id) =>
  `/onboard/accounting-software/display-icon/${id}`;
export const getaccountSoftwareEditURL = (id) =>
  `/onboard/accounting-software/${id}`;
export const getDeactiveAccSoftwareURL = (rowId) =>
  `/onboard/accounting-software/${rowId}/deactivate`;
export const getActiveAccSoftwareURL = (rowId) =>
  `/onboard/accounting-software/${rowId}/activate`;
export const getAccSoftwareStatusURL = (roleId) =>
  `/onboard/accounting-software-status/${roleId}`;
export const getAccAnnatureStatusURL = `/onboard/legal-documents/annature/check-status`;

/**Api ReckonBank Account  */

export const getReckonBankAccountsURL = `/onboard/reckon/bank-accounts`;

export const getReckonAuthorizationCallbackURL =
  "/onboard/reckon/authorization-callback";

export const getReckonSpecificBookURL = "/onboard/reckon/specific-book";

export const getReckonRefreshURL = "/onboard/reckon/refresh-software";
export const getReckonSyncInvoiceURL = "/loan-mgmt/reckon/sync-invoices";

export const getReckonAuthorizeURL = "/onboard/reckon/authorize";

/**Api XeroBank Account  */
export const getXeroBankAccountsURL = (id) =>
  `/onboard/xero/bank-accounts?userAccountId=${id}`;

/**Api MYOB Bank Account  */
export const getMyobBankAccountsURL = `/onboard/myob/bank-accounts`;

/**Api Quickbooks Bank Account  */
export const getQuickbooksAuthorizeURL = "/onboard/quickbooks/authorize";

/**Api Quickbooks Bank Account  */
export const getQuickbooksBankAccountsURL = `/onboard/quickbooks/bank-accounts`;

/**Api Quickbooks Bank Account  */
export const getconnectedQuickbooksURL = (id) =>
  `/onboard/quickbooks/bank-accounts?userAccountId=${id}`;

/**Api Quickbooks Bank Account  */
export const getTrustCorporateGuaranteeFormURL = `/onboard/legal-documents/trust-corporate-guarantee-form`;
export const getOnboardGuaranteeFormURL = `/onboard/legal-documents/agreement-guarantee-form`;

export const getXeroAuthorizationURL = `/onboard/xero/authorize`;

export const getXeroAuthorizationCallbackURL = (id) =>
  `/onboard/xero/authorization-callback?code=${id}`;

export const getQuickbooksAuthorizationCallbackURL =
  "/onboard/quickbooks/authorization-callback";

export const getQuickbooksRefreshURL = "/onboard/quickbooks/refresh-connection";

export const getAplayIdRedirectWebURL = "/onboard/aplyid/redirect-web";
export const getAplayIdRedirectWebTokenURL =
  "/onboard/aplyid/redirect-web/token";
export const getCheckStatusTokenURL = "/onboard/aplyid/check-status/token";

export const getMyobAuthorizeURL = "/onboard/myob/authorize";

export const getQuickbooksSyncInvoiceURL =
  "/loan-mgmt/quickbooks/sync-invoices";

export const getMyobAuthorizationCallbackURL = (id) =>
  `/onboard/myob/callback?code=${id}`;

export const getmyobspecificbookUrl = "/onboard/myob/specific-book";
export const getmyobrefreshsoftwareUrl = "/onboard/myob/refresh-software";
export const getmyobsyncinvoicesUrl = "/loan-mgmt/myob/sync-invoices";
export const getQuoteUserURL = (id) => `/loan-mgmt/quote/user/${id}`;
export const getXeroRefreshURL = `/onboard/xero/refresh-software`;
export const getXeroOrganisationsURL = `/onboard/xero/organisations`;
/* * API Email Template log*/
export const emailTemplateURL = "notify/email-templates";
export const emailUpdateURL = (id) =>
  `notify/email-templates/${id}/toggle-status`;
export const fetchemailTemplateURL = (id) => `/notify/email-templates/${id}`;
export const getEmailIdActiveURL = `/user-mgmt/users/minimum-active-users`;
export const getEmailSendURL = (templateSlug) =>
  `/notify/email-templates/send-email/${templateSlug}`;

/* * API SMS Template log*/
export const getsmsTemplateURL = "/notify/sms-templates";
export const getsmsUpdateURL = (id) =>
  `notify/sms-templates/${id}/toggle-active`;

export const getsmsdeleteURL = (id) => `/notify/sms-templates/${id}`;
export const getfetchsmsTemplateURL = (id) => `/notify/sms-templates/${id}`;
export const getfetchSmsTemplateDataURL = (id) => `/notify/sms-templates/${id}`;
export const getEditSmsTemplateDataURL = (id) => `/notify/sms-templates/${id}`;

export const getCreditLimitURL = (userId) => `/notify/credit-limit/${userId}`;

export const getCreditLimitRequestURL =
  "/notify/credit-limit/request-credit-limit";

/* * API Endpoint for Activity Logs*/
export const getRepaymentLogsURL = "/loan-mgmt/repayment-change-logs";

/* * API Endpoint for loadFeeCalculatorData*/
export const getFeeCalculatorDataURL = (id) =>
  `/loan-mgmt/quote/fee-calculation-provided-date/${id}`;

/* * API Endpoint for Email Content Monthly Commison Report*/
export const getEmailContentMonthlyCommisonURL =
  "/reporting/monthly-commission-reports/email-content-monthly-commission-report";

/* * API Endpoint for All Email Content Monthly Commison Report*/
export const getAllEmailContentMonthlyCommisonURL =
  "/reporting/monthly-commission-reports/email-content-monthly-commission-report/all";

/* * API Endpoint for User Invoice details*/
export const getBankDocumentDownloadURL = (id) =>
  `/loan-mgmt/quote-status/${id}/advance/download`;
export const getUpdateOverdueDateURL = "/loan-mgmt/quote/update-overdue-date";
export const getDeleteOverdueDateURL = "/loan-mgmt/quote/delete-overdue-date";
export const getPasswordConfirmationURL = "/auth/admin/validate-password";
export const getConfirmForgetPasswordURL = "/auth/confirm-forget-password";
export const getChangePasswordURL = "/auth/admin/change-password";
export const getRevertToAdminURL = "/auth/admin/revert-to-admin";
export const getSend2FACodeURL = "/auth/send-2fa-code";
export const getOnboardBankAccURL = "/api/v1/onboard/bank-accounts/user/{id}";

export const getInvoiceByIdsURL = "/loan-mgmt/invoice/get-invoice-by-ids";
export const getVerify2FACodeURL = "/auth/verify-2fa-code";
export const getSendEmailOtpURL = "/user-mgmt/users/send-email-otp";
export const getVerifyEmailOtpURL = "/user-mgmt/users/verify-email-otp";
export const getForgetPasswordURL = "/auth/forget-password";
export const getJobsByIdURL = (jobId) => `/loan-mgmt/jobs/${jobId}`;

/* * API Update password then approved */
export const getUpdatePasswordURL = (selectedTabId) =>
  `/user-mgmt/trust-corporates/${selectedTabId}/soft-delete`;

export const getFindByUserAccountIdsURL = (ccEmailAddresses) =>
  `/user-mgmt/users/find-by-user-account-ids?userAccountIds=${ccEmailAddresses.join(",")}`;

/* * API Endpoint for Owner */
export const getOwnerEmailTriggerURL = (id) =>
  `/onboard/legal-documents/${id}/send-agreement-owner`;
export const getOwnerEmailTriggerIdOnlyURL = (id) =>
  `/onboard/legal-documents/resend-id-verification-link/${id}`;

//** API Endpoint for fetchCountryCode*/
export const getFetchCountryCodeURL = "/int/bdc/validate-phone-number";

export const getIdentificationURL = `/onboard/identification/user`;

export const getIdentificationDocsURL = (tabIndex) =>
  `/onboard/identification-docs/${tabIndex}`;

export const getIdentificationDocsSoftDeleteURL = (rowId) =>
  `/onboard/identification-docs/${rowId}/soft-delete`;

export const getCheckBackendAccessURL = `/user-mgmt/users/check-backend-access`;

export const getIdentificationDocsDownloadURL =
  "/onboard/identification-docs/download";

export const getIdentificationDocsToggleVerificationURL = (rowId) =>
  `/onboard/identification-docs/${rowId}/toggle-verification`;

/* * API Endpoint for owner tab identification save file data*/
export const getOwnerSaveFileDataURL = `/onboard/identification`;
export const getIdentificationDocURL = (id) =>
  `/onboard/identification-docs/${id}`;

//** API Endpoint for PhoneNumberChange*/
export const getPhoneNumberChangeURL = (id) =>
  `user-mgmt/users/secondary-users/${id}`;

/* * API Endpoint for userManagement supporting doc */
export const getUserManagementSupportingDocURL = (id) =>
  `/user-mgmt/supporting-docs/${id}`;

/* * API Endpoint for userManagement permissions grouped */
export const getUserManagementPermissionsGroupedURL = `/user-mgmt/permissions/grouped`;
export const getUserManagementPermissionsURL = `/user-mgmt/permissions`;
export const getUserManagementPermissionsUploadURL = `/user-mgmt/permissions/upload-json-file`;
export const getUserManagementPermissionsDownloadURL = `/user-mgmt/permissions/download-json`;
export const getUserManagementPermissionsDataURL = (id) =>
  `/user-mgmt/permissions/${id}`;

/* * API Endpoint for userManagement supporting doc */
export const getUserManagementSupportingUploadDocURL = `/user-mgmt/supporting-docs`;

/* * API Endpoint for userManagement toggle varification */
export const getUserManagementToggleVerificationURL = (id) =>
  `/user-mgmt/supporting-docs/${id}/toggle-verification`;

/* * API Endpoint for userManagement supporting doc delete */
export const getUserManagementSupportingDocDeleteURL = (id) =>
  `/user-mgmt/supporting-docs/${id}/soft-delete`;

/* * API Endpoint for userManagement supporting doc download */
export const getUserManagementSupportingDocDownloadURL =
  "/user-mgmt/supporting-docs/download";

/* * API Endpoint for userManagement supporting doc comments */
export const getUserManagementSupportingDocCommentsURL = (id) =>
  `/user-mgmt/supporting-docs/${id}/comments`;

/* * API Endpoint for fetchSecondary UserData  */
export const getfetchSecondaryUserDataURL = (id) =>
  `/user-mgmt/users/${id}/secondary-users`;

/* * API Endpoint for userManagement saveNameFieldData */
export const getUserManagementSaveNameFieldDataURL = (id) =>
  `/user-mgmt/users/secondary-users/${id}`;

export const getUserManagementSecondaryUsersURL = `/user-mgmt/users/secondary-users`;

/* * API Endpoint for userManagement supporting doc email */
export const getUserManagementSupportingDocEmailURL = (id) =>
  `/user-mgmt/supporting-docs/send-email/${id}`;

/* * API Endpoint for set password reset email */
export const getSetPasswordResetEmailURL = (id) =>
  `/user-mgmt/users/${id}/send-password-reset-email`;

/* * API Endpoint for Platform API*/
export const getloadPlatformPartnersURL = `pay-sync/platform-partner`;
export const getDeletePlatformPartnersURL = (id) =>
  `/pay-sync/platform-partner/${id}`;
export const getArchivePlatformPartnersURL = (id) =>
  `/pay-sync/platform-partner/${id}/archive`;
export const getRestorePlatformPartnersURL = (id) =>
  `/pay-sync/platform-partner/${id}/restore`;
export const loadPlatformPartnersURL = (id) =>
  `/pay-sync/platform-partner/${id}`;
export const getValidatePlatformPartnersURL = (id) =>
  `/pay-sync/platform-partner/${id}`;
export const getPaymentsByQuoteURL = (id) =>
  `/pay-sync/payments/by-quote/${id}`;
export const getPaymentsByRowIdURL = (rowId) => `/pay-sync/payments/${rowId}`;

//* * API Endpoint for Promocode API*/
export const createPromoCodeURL = `/loan-mgmt/promo-code`;
export const getloadPromoCodeURL = (id) => `/loan-mgmt/promo-code/${id}`;
export const getUpdatePromoCodeURL = (id) => `/loan-mgmt/promo-code/${id}`;

export const getPromocodePlatformURL = `/loan-mgmt/promo-code/search`;
export const getDelatePromocodePlatformURL = (id) =>
  `loan-mgmt/promo-code/${id}`;
export const getReferalEmailpromocodeURL = `/loan-mgmt/promo-code/referral-email/user-list`;
//* * API Endpoint for Update Funded Amount */
export const getUpdateFundedAmountURL = `/loan-mgmt/quote/update-funded-amount`;
//* * API Endpoint for legal doc */
export const getLegalDocumentURL = (id) => `/onboard/legal-documents/${id}`;
export const getSupportingDocumentURL = (id) =>
  `/user-mgmt/supporting-docs/${id}`;
//* * API Endpoint for legal download */
export const getOnBoardLegalDocDownloadURL = (id) =>
  `/onboard/legal-documents/${id}/download`;
//* * API Endpoint for EmailSendEnvURL */
export const getEmailSendEnvURL = (id) =>
  `/onboard/legal-documents/${id}/send-trustCorporate-envelope`;
//* * API Endpoint for sending the Directors Resolution envelope */
export const getSendDirectorsResolutionEnvelopeURL = (id) =>
  `/onboard/legal-documents/${id}/send-directors-resolution-envelope`;
//* * API Endpoint for generating the demand letter pack */
export const getGenerateDemandLettersURL = (id) =>
  `/onboard/demand-letters/${id}`;
//* * API Endpoint for Update Trust Corporates */
export const getUpdateTrustCorporatesURL = (id) =>
  `/user-mgmt/trust-corporates/${id}`;
//* * API Endpoint for delete Trust Corporates */
export const getDeleteTrustCorporatesURL = (id) =>
  `/user-mgmt/trust-corporate-associate/${id}`;

// api  Update trust data and call API to save changes
export const getUpdateTrustDataURL = `/user-mgmt/trust-corporate-associate`;

// api handle add new trust
export const getCreateNewTrustURL = "/user-mgmt/trust-corporates";

//* * API Endpoint for delete Trust LegalDocumentData */
export const getLegalDocumentDataURL = (id, tabIndex) =>
  `/onboard/legal-documents/${id}/trust-corporate/${tabIndex}`;

//* * API Endpoint for soft delete */
export const getDataSoftDeleteURL = (id) =>
  `/onboard/legal-documents/${id}/soft-delete`;

//API Endpoint for handleFileDownload
export const getFileDownloadURL = `/onboard/legal-documents/download`;

// API Endpoint for onclick to Verification
export const getToggleVerificationURL = (id) =>
  `/onboard/legal-documents/${id}/toggle-verification`;

// API Endpoint handleDocUploadButtonClick
export const getDocUploadURL = (id) => `/onboard/legal-documents/${id}/upload`;

// API Endpoint owner email send
export const getOwnerEmailSendURL = (id) =>
  `/onboard/legal-documents/send-guarantee-email/${id}`;

//API Endpoint for handleSendFileButtonClick
export const getSendFileButtonClickURL = (id) =>
  `/onboard/legal-documents/send-email/${id}`;

//API Endpoint for fetchCorporateCommentData
export const getCorporateCommentDataURL = (id) =>
  `/user-mgmt/comments/users/${id}`;

//API Endpoint for updateComment
export const getUpdateCommentURL = `/user-mgmt/comments`;

//API Filter out deleted items

export const getFilterOutDeletedItemsURL = (id, selectedTabId) =>
  `/user-mgmt/comments/user/${id}/trustCorporateId/${selectedTabId}`;

export const getCorporateTrustAssociateCommentURL = (id) =>
  `/user-mgmt/comments/corporateTrustAssociate/${id}`;

//API Endpoint for Comment
export const getCommentURL = (id) => `/onboard/legal-documents/${id}/comments`;

//API Endpoint for soft delete comment
export const getSoftDeleteCommentURL = (id) =>
  `/user-mgmt/comments/${id}/soft-delete`;

//API Endpoint for upload
export const getUploadURL = (id) => `/onboard/legal-documents/${id}/upload`;

//* * API Endpoint for LoanLessHundread  */
export const getLoanLessHundreadURL = `reporting/quote/quotes-less-than-hundred`;

/* API Endpoint for Invoice Page */
export const getQuotesByUserURL = "/loan-mgmt/quote/quotes-by-user";
export const getToFundDataByURL = "/loan-mgmt/invoice/search";

export const getPostQuotePDFUrl = (id) =>
  `/loan-mgmt/quote/generate-pdf?quoteId=${id}`;
export const getGenerateQuotePDFUrl = `/loan-mgmt/quote/generate-pdf`;

export const getInvoiceDetailsURL = (id) => `/loan-mgmt/invoice/${id}`;

export const getInvoiceCommentsURL = (id) =>
  `/loan-mgmt/invoice/${id}/comments`;

export const getCreateCompletePricingPlanURL = `/loan-mgmt/pricing-plans/create-complete`;

export const getUpdateDebtorNameURL = `/loan-mgmt/quote/update-debtor-name`;

export const loanInvDownloadURL = `/loan-mgmt/invoice/download`;

export const getRefreshInvoiceStatusURL =
  "/loan-mgmt/invoice/refresh-invoice-status";

export const getLoanManagementquoteURL = (id) => `/loan-mgmt/quote/${id}`;
export const getLoanManagementFMFBquoteURL = (id) =>
  `/loan-mgmt/quote/fmfb-quote-id/${id}`;

/* API Endpoint for Xero sync Invoice Page */
export const getXeroSyncInvoiceURL = "/loan-mgmt/xero/sync-invoices";

/*API Endpoint for ClientDetails Page*/
export const getUsersPPSRURL = (id) => `/user-mgmt/users/ppsr/${id}`;
export const getUserIdentificationURL = (id) =>
  `/onboard/identification/user-account/${id}`;
export const getUserAddressURL = (id) => `/user-mgmt/user-addresses/${id}`;
/* API Endpoint for Property */
export const getOwnerPropertyAddressURL = (id) =>
  `/onboard/property-address/${id}`;
export const getOwnerPropertyAddressTokenUrl =
  "/onboard/property-address-by-token";

/* API Endpoint for user-mgmt industry-types */
export const getIndustryTypesURL = `/user-mgmt/industry-types`;

/* API Endpoint for user-mgmt industry categories  */
export const getIndustryCategoriesURL = `/user-mgmt/user-industry-categories`;

/* API Endpoint for user-mgmt update-user-pricing-plan  */
export const getUserManagementUpdatePricingPlansURL = `/loan-mgmt/pricing-plans/update-user-pricing-plan`;

/* * API Endpoint for nzbn user  */
export const getNZBNUserURL = (getNZBN, tabIndex) =>
  `/user-mgmt/nzbn/${getNZBN}/requesters/USER/${tabIndex}`;

/* * API  onboard/liability-expense-bank-accounts */
export const getLiabilityExpenseBankAccountsURL = (id) =>
  `/onboard/liability-expense-bank-accounts?userAccountId=${id}`;

/* * API  reporting checklist generate db */
export const getReportingChecklistGenerateDBURL = `/reporting/checklist/generate-db`;

/* * API  reporting generate refresh */
export const getReportingChecklistGenerateRefreshURL = `/reporting/checklist/generate-refresh`;

export const getEmailSentMonthlyCommissionReportURL = `/reporting/monthly-commission-reports/email-sent-monthly-commission-report/all`;

export const getReportEmailSentMonthlyCommissionReportURL = `/reporting/monthly-commission-reports/email-sent-monthly-commission-report`;

export const getQuestionResponsesQueryForFundingURL = `/reporting/question-responses/query-for-funding`;

export const getQuestionResponsesQueryForFundingUploadURL = `/reporting/question-responses/query-for-funding/upload?token=`;

/* API Endpoint for Comments Update */
export const getCommentUrl = (tabIndex) =>
  `/user-mgmt/comments/users/${tabIndex}`;
export const getPostCommentUrl = "/user-mgmt/comments";
export const getDeleteCommentUrl = (commentId) =>
  `/user-mgmt/comments/${commentId}/soft-delete`;

export const getPostQuoteCommentUrl = (id) => `/loan-mgmt/quote/${id}/comments`;
export const getPostPaymentCommentUrl = (id) =>
  `/loan-mgmt/quote/${id}/payment-comments`;
export const getDeletePaymentCommentUrl = (id, commentId) =>
  `/loan-mgmt/quote/${id}/payment-comments/${commentId}`;
export const getSalesTrustCrprteUpdateComment =
  "/reporting/sales-trust-corporates/update-comment";

/* API Endpoint for Repay Date Change */
export const getPostDateUrl = "/loan-mgmt/quote/change-repay-date-confirmation";
export const getPutDateUrl = "/loan-mgmt/quote/update-repay-date";
export const getUpdateRepayDateForCustomerUrl =
  "/loan-mgmt/quote/update-repay-date-for-customer";
export const getSetRepaymentDateUrl = (invoiceId) =>
  `/loan-mgmt/invoice/set-repayment-date/${invoiceId}`;
export const getPutDateForSingleQuoteUrl =
  "/loan-mgmt/quote/update-repay-date-for-single-quote";

export const getDownloadFundingNoticeUrl = (quoteId) =>
  `/loan-mgmt/quote/download-funding-notice?quoteId=${quoteId}`;

/* API Endpoint for All account Steps */
export const getAgreementDownloadUrl =
  "/onboard/legal-documents/agreement/download";
export const getAgreementUploadUrl = "/onboard/legal-documents/upload";
export const getLoadAgreementUploadLaterUrl =
  "/onboard/legal-documents/upload-later-status";
export const getAgreementUploadUrlLaterStatusUrl =
  "/onboard/legal-documents/upload-later";
export const getAgreementUploadUrlLaterIDUrl = (id) =>
  `/onboard/legal-documents/upload-later/${id}`;
export const getAgreementUploadUrlLaterIDTokenUrl = `/onboard/legal-documents/upload-later/token`;
export const getCheckTokenValidityUrl = `/onboard/legal-documents/check-token-validity`;

export const getBillingRequestFlowsUrl =
  "/onboard/gocardless/billing-request-flows";

export const getAcceptCreditConsentUrl =
  "/onboard/aplyid/accept-credit-consent";
export const getAcceptCreditConsentTokenUrl =
  "/onboard/aplyid/accept-credit-consent-by-token";
export const getUserOnboardUrl = "/user-mgmt/users/secondary-users/onboard";

/* API Endpoint for GoCardlessCallBack */
export const getBillingRequestStatusUrl = (idParams) =>
  `/onboard/gocardless/billing-requests/${idParams}/status`;

/* API Endpoints */
export const getPostSalesLeadUrl = "/user-mgmt/sales-leads";
export const getGenerateEmailUrl =
  "/onboard/legal-documents/generate-and-email";
export const getSecondaryUsersUrl = (secondaryUserId) =>
  `/user-mgmt/users/secondary-users/${secondaryUserId}`;
export const getSendPasswordResetEmailUrl = (ownerIDs) =>
  `/user-mgmt/users/${ownerIDs}/send-password-reset-email`;
export const getRegisterFinancialStatementUrl = (id) =>
  `/user-mgmt/ppsr/nz/${id}/register-financing-statement`;
export const getUserPPSRUrl = (tableId) => `/user-mgmt/users/ppsr/${tableId}`;
export const getVerifyPhoneNumberUrl = (id) =>
  `/user-mgmt/users/${id}/verify-phone-numbers`;
export const getPopupCommentsUrl = (id) => `/user-mgmt/user/${id}/popup`;
export const getPropertyUpdatedUrl = (id) =>
  `/user-mgmt/users/property-updated/${id}`;
export const getQuoteEmailSent = "/notify/quotes-email/email-sent";
export const getStatusDetailsUrl = (id) =>
  `/user-mgmt/users/${id}/status-details`;

export const getQuoteExportUrl = (id) => `/loan-mgmt/quote/export?${id}`;
export const getQuoteFeeAddjustmentsUrl = `/loan-mgmt/quote-fee-adjustments`;
export const getQuoteFeeEditjustmentsUrl = (id) =>
  `/loan-mgmt/quote-fee-adjustments/${id}`;

export const getRegisterFinanceStatmntUrl = (id) =>
  `/user-mgmt/ppsr/au/${id}/register-financing-statement`;
export const getIndustryReportDownloadUrl = `/reporting/industry-sector-report/download`;
export const getExportToCsvUrl = (startDate, expiryDate) =>
  `/notify/activities/export-to-csv?startDate=${startDate}&endDate=${expiryDate}`;
export const getSalesReferralCSVUrl = `/user-mgmt/sales-referral-reports/sales-referral/csv`;

export const getuploadInvoiceUrl = `/loan-mgmt/invoice/upload-invoice`;
export const loanInvUploadDocURL = (invoiceId) =>
  `/loan-mgmt/invoice/upload-invoice-document?invoiceId=${invoiceId}`;

export const getOnboardSendLinkUrl = `/onboard/aplyid/phone/send-link`;
export const getOnboardSendLinkTokenUrl = `/onboard/aplyid/phone/send-link/token`;

export const getPaySyncPaymentsPut = (id) => `/pay-sync/payments/${id}`;
export const getPaySyncPaymentsUrl = "/pay-sync/payments";

export const getQuotesStatusUrl = "/loan-mgmt/quote-status";
export const getBulkUpdateQuotesStatusUrl =
  "/loan-mgmt/quote-status/bulk-update";

export const getReferrralEmailSendUrl =
  "/loan-mgmt/promo-code/referral-email/send";
export const getSendEmailListUrl = "/user-mgmt/users/checklist/send-email-list";
export const getSendQstnEmailUrl = "/reporting/batches/sent-questions-email";
export const getCustomerDetailsDownloadUrl =
  "/reporting/customer-details-report/download";

export const getSendSmsTemplateUrl = "/notify/sms-templates/send";
export const getSendEmailTemplateUrl = (id) =>
  `/notify/email-templates/send-email/${id}`;

export const getSubmittedInvcsRptDownloadUrl =
  "/loan-mgmt/quote/submitted-invoice-time-report/download";
export const getIdentificationDocsUrl = "/onboard/identification-docs";
export const getPutIdentificationDocsUrl = (id) =>
  `/onboard/identification-docs/${id}`;

export const getUserPropertiesUrl = "/user-mgmt/properties";
export const getCopyUserPropertiesUrl = (id) => `/user-mgmt/properties/${id}`;

// Endpoints For MultiStepForm
export const getOnboarStatusCheckUrl = "/onboard/aplyid/check-status";
export const getOnboarStatusCheckTokenUrl =
  "/onboard/aplyid/check-status/token";
export const getLiabltyExpnsStatusUrl =
  "/onboard/reckon/liability-and-expense-accounts";
export const getMyobAccExpnsUrl = "/onboard/myob/account-expense";
export const getMyobAccLiabilityUrl = "/onboard/myob/account-liability";
export const getXeroExpnsAccUrl = "/onboard/xero/expense-accounts";
export const getXeroAccLiabilityUrl = "/onboard/xero/liability-accounts";
export const getXeroWritebackAccountsUrl = "/onboard/xero/writeback-accounts";
export const getQuickbooksExpnsAccUrl = "/onboard/quickbooks/expense-accounts";
export const getQuickbooksAccLiabilityUrl =
  "/onboard/quickbooks/liability-accounts";
export const getReckonTaxGrpsUrl = "/onboard/reckon/taxgroups";

export const getReckonBankAccUrl = "/onboard/reckon/bank-accounts";
export const getXeroBankAccUrl = "/onboard/xero/bank-accounts";
export const getMyobBankAccUrl = "/onboard/myob/bank-accounts";
export const getQuickBooksBankAccUrl = "/onboard/quickbooks/bank-accounts";
export const getBankAccountsUpsertUrl = "/onboard/bank-accounts/upsert";
export const getBankAccountsUrl = "/onboard/bank-accounts";
export const getBankAccountStatementRemoveUrl = (id) =>
  `/onboard/bank-accounts/user/${id}/statement`;
export const getSecondaryUserUrl =
  "/user-mgmt/users/onboarding-secondary-users";
export const getUpdateOnboardStepsUrl = "/onboard/update-onboarding-steps";
export const getUpdateOnboardStepsTokenUrl =
  "/onboard/update-onboarding-steps-by-token";
export const getCountryCodeUrl = "/onboard/legal-documents/primary-country";

export const getProfileChangePassUrl = "/auth/profile/change-password";
export const getGetInvcsByIdUrl = "/loan-mgmt/invoice/get-invoice-by-ids";

export const getActivitySearchUrl = "/notify/activities/search";
export const getCustomersUrl = "/loan-mgmt/customers";
export const getClientStatusBulkUrl =
  "/user-mgmt/client-status/users/bulk-status";
export const getClientStatusUserUrl = (id, userStatus) =>
  `/user-mgmt/client-status/users/${id}?userStatusId=${userStatus}`;

export const getDirectorshipsUrl = (id) => `/user-mgmt/directorships/${id}`;
export const getDirectorshipsSearchCompanyUrl = (id) =>
  `/user-mgmt/directorships/search/company/${id}`;
export const getDirectorshipsPostUrl = `/user-mgmt/directorships`;

export const getUserSoftwareDetailsUrl = (id) =>
  `/onboard/user-software-details/${id}`;
export const getUserAccountingBankAccUrl = (softwareId, id) =>
  `/onboard/accounting-bank-accounts/${softwareId}/user/${id}`;
export const getGocardLessBankAccUrl = `/onboard/gocardless/bank-accounts`;
export const getDirectDebitUrl = "/onboard/direct-debit";
export const getGocardLessMandateStatusUrl = (mandateId) =>
  `/onboard/gocardless/mandates/${mandateId}/status`;
export const getGocardLessMandatesUrl = (mandateId) =>
  `/onboard/gocardless/mandates/${mandateId}`;
export const getDemoUserUrl = "/user-mgmt/demo-users/create";
export const getDemoinvoiceUrl = (userId) =>
  `/loan-mgmt/demo-invoice/${userId}`;
export const getRegisterUrl = "/user-mgmt/register";
export const getLeagalAgreementDownloadUrl = (id) =>
  `/onboard/legal-documents/agreement/download/${id}`;
export const getLeagalAgreementDownloadTokenUrl = `/onboard/legal-documents/agreement/download/token`;
export const getLeagalAgreementGenerateDownloadTokenUrl = `/onboard/legal-documents/agreement/generate-download/token`;
export const getLeagalAgreementUploadUrl = (token) =>
  `/onboard/legal-documents/upload-agreement?token=${token}`;
export const getLeagalAgreementUploadTokenUrl = `/onboard/legal-documents/upload/token`;
export const getRiskAdvsrGenerateQuoteUrl = (id) =>
  `/risk-advisor/credit-score/generate/quote/${id}`;

// for KPI report
export const getKpiReportsDataURL = "/reporting/kpi-report/report/table";
export const getKpiGeneratedReportsDataURL =
  "/reporting/kpi-report/kpi-files-data";
export const getOthersOwnerUrl =
  "/user-mgmt/users/secondary-users/create-owner";
export const getKpiReportsModalDataURL =
  "/reporting/kpi-report/model-view-popup";
export const getKpiReportsGenerateDownloadDataURl =
  "/reporting/kpi-report/request-download-file-generation";
export const getKpiGeneratedFileDownloadURL =
  "/reporting/kpi-report/kpi-excel-download";
export const getRefreshKpiReportURL = "/reporting/kpi-report/generate";
export const getRefreshKpiReportDataStatusURL =
  "/reporting/kpi-report/leatest-kpi-request-status";
export const getEmailTemplatePayNowUrl = (id) =>
  `/pay-sync/failed-payment-intents/${id}/pay-now`;
export const getEmailTemplatedayPaymentUrl = (id) =>
  `/pay-sync/failed-payment-intents/${id}/date-for-payment`;
export const getEmailTemplateCaptureUrl = (id) =>
  `/pay-sync/failed-payment-intents/${id}/capture`;
export const getPayNowSubmitUrl = "/pay-sync/failed-payment-intents/pay-now";
export const getDateForPaySubmitUrl =
  "/pay-sync/failed-payment-intents/date-for-payment";

// for promo code usage details (who used the code). A promo code only has to be
// non-blank and 6+ characters, so it can carry `#`, `?` or `/`. Encoding keeps `#`
// and `?` inside the path segment; an encoded `/` (`%2F`) is rejected by Spring with
// a 400 rather than routing elsewhere. Decision 0054 covers the character allowlist
// that belongs on promo-code creation.
export const getPromocodeUsageDetailsUrl = (promoCode) =>
  `/loan-mgmt/promo-code/${encodeURIComponent(promoCode)}/discount-details`;

// for promo code csv download
export const getPromocodeCsvDownloadUrl = (promoCode) =>
  `/loan-mgmt/promo-code/${encodeURIComponent(promoCode)}/discount-details/csv`;

// for Unlock user  Usermangment
export const getUnlockUserUrl = `/auth/users/credential/change-locked-status`;

// for single software name fetch
export const getLastConnectedSoftware = `/onboard/user-software/last-connected-software-recommendation`;
// Monthly Comission Invoice Popup URL
export const getMonthlyComissionInvoicePopupUrl =
  "/loan-mgmt/popup/monthly-commission-poup";

// Get All Roles
export const getAllRolesUrl = `/user-mgmt/roles/all-roles`;

export const getAccountUploadDocumentsUrl = (id) =>
  `/onboard/authorize-user/${id}`;

export const getRepaymentDateChangeUrl = `/loan-mgmt/quote/update-repay-date/payment-report`;

// API Endpoint for UserManagment */
export const getUserManagementInitURL = (id) => `/user-mgmt/users/${id}/init`;
export const getUserManagementClientDetailsURL = (id) =>
  `/user-mgmt/users/${id}/customer-details`;
export const getUserManagementIdentificationURL = (id) =>
  `/user-mgmt/users/${id}/owner/identification`;
export const getFmfbtoFrUrl = `/run`;
export const getMigrationStatusUrl = `/status`;
export const getArchivePaymentReportData = `/pay-sync/payments/change-archive-status`;
export const getIdentificationUpdateURL = (id) =>
  `/user-mgmt/users/${id}/personal-details`;
export const getIdentificationDocUpdateURL = (id) =>
  `/onboard/identification-docs/user/${id}`;
export const getChangeDateRepaidUrl = `/loan-mgmt/quote/change-date-repaid`;
export const getXeroAcceptCreditConcentUrl = `/onboard/xero/accept-credit-consent`;
export const getHubspotTrakingUrl = `user-mgmt/register`;
export const getUserPermissionUrl = `/user-mgmt/users/get-permission`;
export const getFeeAdjustmentsURL = (id) =>
  `/loan-mgmt/quote-fee-adjustments/quote/${id}`;
export const getPipedriveSyncURL = (id, forceSync = true) =>
  `/user-mgmt/users/${id}/sync/pipedrive?forceSync=${forceSync}`;
export const getQuoteSummaryUrl = `/loan-mgmt/quote/quotes-summary`;
export const getTotalOwingNotZeroReportUrl = `/reporting/total-owing-not-zero-report`;
export const getTotalOwingNotZeroReportDownloadUrl = `/reporting/total-owing-not-zero-report/download`;
export const getAccountsReceivableReportUrl = `/reporting/accounts-receivable-report`;
export const getAccountsReceivableReportDownloadUrl = `/reporting/accounts-receivable-report/download`;
export const getAcceptedConsentDownloadUrl = (id) =>
  `/onboard/aplyid/dowload-credit-consent/${id}`;

export const getPartnerDashboardURL = `/user-mgmt/partner-portal/dashboard`;
export const getPartnerCustomersURL = `/user-mgmt/partner-portal/customers`;
export const getPartnerCustomerDetailURL = (id) =>
  `/user-mgmt/partner-portal/customers/${id}`;
export const getPartnerCustomerInvoicesURL = (id) =>
  `/user-mgmt/partner-portal/customers/${id}/invoices`;
export const getPartnerCommissionURL = `/user-mgmt/partner-portal/commission`;
export const createPartnerCustomerURL = `/user-mgmt/partner-portal/customers`;
export const exportPartnerCustomersURL = `/user-mgmt/partner-portal/customers/export`;
export const uploadPartnerCustomerDocsURL = (id) =>
  `/user-mgmt/partner-portal/customers/${id}/documents`;

export const getCustomerStatementURL = (params) =>
  `/loan-mgmt/quote/customer/statement?${params}`;
export const getClientInvoicesTotalsByStatusUrl = (userAccountId) =>
  `/loan-mgmt/quote/user/${userAccountId}/totals-by-state`;

export const getPpsrNoGapMoreThanTwentyDaysUrl = `/user-mgmt/ppsr/nz/ppsr-no-gap-more-than-twenty-days`;
export const getUpdateFtAgreementCompletedDateUrl = `/user-mgmt/aux/update-ft-agreement-completed-date`;

/* * API Endpoint for funding-batches-download-excel*/
export const getFundingBatchesDownloadExcelURL =
  "/loan-mgmt/funding-batches/funding-batches-download-excel";

export const getUploadPPRequiredURL = "/loan-mgmt/pop-documents/upload-pop";
export const getDownloadPOPRequiredURL = (quoteId) =>
  `/loan-mgmt/pop-documents/download/${quoteId}`;

export const getOnboardingURL = (id) => `/onboard/onboarding-steps/${id}`;
export const getCreateOnboardingStepURL = `/onboard/create-onboarding-step`;
export const getAboutYourBusinessURL = (id) =>
  `/onboard/about-your-business/${id}`;
export const getUpdateAboutYourBusinessURL = `/onboard/create-or-update-about-your-business`;
export const getUpdateOnboardingRoleURL = `/onboard/create-redirect-web-for-owner-or-director`;
export const getOnboardingRoleDataURL = (id) =>
  `/onboard/credit-consent-your-role/${id}`;
export const getVerifyIdentityDataURL = (id) =>
  `/onboard/owner-or-director-details/${id}`;
export const getOnboardOwnersDataURL = (id) =>
  `/user-mgmt/properties/owners/${id}`;
export const getUpdateOnboardOwnersDataURL = `/user-mgmt/properties/owners`;
export const getOnboardOwnersListURL = `/user-mgmt/users/secondary-users`;
export const getOnboardNZBNDataURL = (id) => `/user-mgmt/nzbn/lookup/${id}`;
export const getOnboardNzbnSearchURL = "/user-mgmt/nzbn/organization";
export const getOnboardCorporateNzbnSyncURL = (nzbn, corporateId) =>
  `/user-mgmt/nzbn/lookup/${nzbn}/trust-corporates/${corporateId}`;
export const getUploadTrustFileURL = `/onboard/legal-documents/upload-onboarding-file`;
export const getGetTrustFileURL = (id) =>
  `/onboard/legal-documents/onboarding-files/${id}`;
export const getDeleteTrustFileURL = (id) =>
  `/onboard/legal-documents/onboarding-file/${id}`;
export const getUpdateTrustDetailsURL = `/user-mgmt/trust-corporates/trust-details`;
export const getTrustDetailsURL = (id, trustType) =>
  `/user-mgmt/trust-corporates/${id}/associates?trustType=${trustType}`;
export const getDeleteTrustDetailsURL = (associatesId) =>
  `/user-mgmt/trust-corporate-associate/${associatesId}`;
export const getCreateBusinessDetailsURL = (id) =>
  `/user-mgmt/users/${id}/business-details`;
export const getBusinessDetailsURL = (id) =>
  `/user-mgmt/users/${id}/business-details`;
// Every director the account's business details record, in one shape. User-management
// owns the reading of that data, so a caller reads this rather than the raw
// business_details map and its several record shapes.
// Removes one person the signed-in account holds. DELETE /user-mgmt/users/{id}
// cannot: it refuses any account that has a primary user, which is every secondary
// user.
export const getDeleteSecondaryUserURL = (secondaryUserId) =>
  `/user-mgmt/users/secondary-users/${secondaryUserId}`;
export const getDirectorRosterURL = (id) =>
  `/user-mgmt/users/${id}/director-roster`;
export const getUpdateBusinessDetailsURL = (userAccountId, personType, index) =>
  `/user-mgmt/users/${userAccountId}/business-details/${personType}/${index}`;
// uuid names the one person to remove. The position is still in the path, because a
// row stored before rows carried an id has no uuid to send and the server falls back
// to it.
export const getDeleteBusinessDetailsURL = (
  userAccountId,
  personType,
  index,
  uuid
) =>
  `/user-mgmt/users/${userAccountId}/business-details/${personType}/${index}${
    uuid ? `?uuid=${encodeURIComponent(uuid)}` : ""
  }`;
export const getInitiateAgreementURL = (userAccountId) =>
  `/onboard/agreement/${userAccountId}/initiate`;
export const getTrustCorporateInitiateAgreementURL = (
  userAccountId,
  trustCorporateId
) => `/onboard/${userAccountId}/trust-corporate/${trustCorporateId}/initiate`;
export const getTrustDetailsUpdateURL = `/user-mgmt/trust-corporates/trust-details`;
export const getDirectorShareholderCreateURL = `/user-mgmt/trust-corporates/director-shareholder`;
export const getDeleteShareholdingCompanyURL = (userAccountId, corporateId) =>
  `/user-mgmt/trust-corporates/${userAccountId}/remove-director-shareholder/${corporateId}`;
export const getCorporateCompanyDataURL = (userAccountId, corporateId) =>
  `/user-mgmt/trust-corporates/${userAccountId}/director-shareholder/${corporateId}`;
export const getTrustAssociatesURL = (userid) =>
  `/user-mgmt/trust-corporates/${userid}/associates/by-trust-types?trustTypes=TRADING_TRUST,PROPERTY_TRUST,CORPORATE_TRUST`;
export const getTrustsByTrustTypeURL = (userid, trustType) =>
  `/user-mgmt/trust-corporates/${userid}/associates/by-trust-types?trustTypes=${trustType}&includeEmpty=true`;
